export default __webpack_public_path__ + "static/media/sale-fiolet.74ee4ce5.svg";